import styled from "styled-components";

import LogoutButton from "./LogoutButton";
import ShareQRCodeButton from "./ShareQRCodeButton";

interface StatusDotProps {
    $isSessionActive: boolean;
}

type Props = {
    isSessionActive: boolean;
    codeOnline: string;
    // False on the login page, before authentication
    isConnected: boolean;
};

const WrapperSessionInformation = ({
    codeOnline,
    isSessionActive,
    isConnected,
}: Props) => {
    return (
        <StyledWrapper>
            <ShareQRCodeButton codeOnline={codeOnline}>
                {isConnected && (
                    <StatusDot $isSessionActive={isSessionActive} />
                )}
                <SessionNumber>{codeOnline}</SessionNumber>
                <Divider />
            </ShareQRCodeButton>
            {isConnected && <LogoutButton />}
        </StyledWrapper>
    );
};

const StyledWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding-bottom: 0.25rem;
    @media (min-width: 768px) {
        margin-right: 1rem;
        padding-bottom: 0;
    }
`;

const StatusDot = styled.span<StatusDotProps>`
    flex-shrink: 0;
    width: 0.875rem;
    height: 0.875rem;
    border-radius: 50%;
    background-color: ${(props) =>
        props.$isSessionActive ? "#60b860" : "#607D91"};
`;

const SessionNumber = styled.span`
    font-size: 0.75rem;
    font-weight: bold;
    letter-spacing: 0.1rem;
    color: #333;
`;

const Divider = styled.span`
    align-self: stretch;
    width: 1px;
    margin: 0.35rem 0;
    background-color: #ccc;
`;

export default WrapperSessionInformation;
